// extracted by mini-css-extract-plugin
export default {"msgM":"b33f870c77"};